// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3Rfov","containerItemsCenter":"Skeleton_containerItemsCenter__11Ehu"};